<div class="main-container">
    <div>
        <h3>Create AVI Invoice</h3>
    </div>
    <div *ngIf="invoiceForm" [formGroup]="invoiceForm">
        <div class="invoice-number-form">
            <span>Facture N°</span>
            <span *ngIf="invoiceNumberPrefix">{{invoiceNumberPrefix}}</span>
            <input pInputText style="width: 100px;" formControlName="invoiceNumber">
        </div>
        <p-table #invTable formArrayName="itemForms" [value]="itemForms.controls">
            <ng-template pTemplate="header">
                <tr>
                    <th>Désignation</th>
                    <th>Montant</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-form let-i="rowIndex">
                <tr [formGroupName]="i">
                    <td>
                        <input style="width: 700px;" pInputText formControlName="description">
                    </td>
                    <td>
                        <input pInputText formControlName="amount">
                    </td>
                </tr>

            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td>
                        <span>Montant déjà réglé</span>
                    </td>
                    <td>
                        <span>0</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>Solde</span>
                    </td>
                    <td>
                        
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div>
        <p-button (onClick)="addItemForm()" label="Add item"></p-button>
    </div>
    <div>
        <p-button (onClick)="submitInvoiceForm()" label="Emit this invoice"></p-button>
    </div>
</div>